import { Type } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { BehaviorSubject } from 'rxjs';

export enum ActionType {
  Modal = 'modal',
  Map = 'map',
  Panel = 'panel',
  Route = 'route',
}

export interface IBaseMenu {
  requiredRole?: string[];
}
export interface IMenuModel<T> extends IBaseMenu {
  icon?: Icon;
  iconAux?: Icon; // Para el responsive
  text?: string;
  textInline?: string;
  action?: T;
  component?: Type<any>;
  statefulComponent?: boolean;
  subMenu?: IMenuModel<T>[];
  data?: any;
  dispatcher?: BehaviorSubject<IMenuEvent<T> | undefined>;
  isVisible?: BehaviorSubject<boolean> | boolean;
  alt?: string;
  classMenu?: string;
  url?: string;
  actionType?: ActionType;
  returnPanel?: boolean;
  actionPanel?: T;
  order?: number;
  isSeparator?: boolean;
}

export interface IMenuEvent<A = any, D = any, C = any> {
  action: A;
  data?: D;
  actionType?: ActionType;
  returnMap?: boolean;
  returnAction?: C;
  actionPanel?: string;
}
